import React, { Component } from 'react';

import { Routes as routes } from '../navigation';
import { Header } from '../components';
import '../css/SignIn.css';

class PracticeProfile extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  renderPracticeProfile = (practice) => {
    if (!practice) {
      return null
    }

    return <div className="standard-container">
      <Header title='Practice Information' icon='fas fa-store-alt' button_title='Edit' button_action={ () => { this.props.practiceActions.openEditPractice() }} />
      <div className="flex-container flex-container-row" style={{ marginTop: 10, alignItems: 'center', justifyContent: 'flex-start', padding: 15, paddingTop: 5 }}>
        <div>
          { practice.logo_url ? <img className="image-default" style={{ height: 30, width: 30, borderRadius: 15 }} src={practice.logo_url} />
          : <span className='fas fa-store-alt' style={{ color: '#e7e7e7', fontSize: 30 }}/>
          }
        </div>
        <div style={{ marginLeft: 10 }}>
          <div className="flex-container flex-container-column" style={{ paddingRight: 10, alignItems: 'flex-start' }}>
            <div style={{ fontSize: 13, color: 'grey' }}>{ practice.name }</div>
            <div style={{ fontSize: 12, color: 'grey', marginTop: -3 }}>{ practice.code.toUpperCase() }</div>
          </div>
        </div>
      </div>
    </div>
  }

  render() {

    const allPractices = this.props.practices;
    const selectedPracticeID = this.props.selectedPractice;
    const selectedPractice = allPractices && allPractices[selectedPracticeID] ? allPractices[selectedPracticeID] : null;

    return this.renderPracticeProfile(selectedPractice);
  }

}


export default PracticeProfile
